export enum STARGATE_ROUTES {
  RESALE_INTENTION = 'intencao-de-revenda',
  EXTENDED_CAPTATION = 'ciclo-estendido',
  ERROR_500 = '500',
  ERROR_401 = '401',
  ERROR_403 = '403',
  ERROR_GENERIC = 'error-generic',
  ERROR_VDF = 'revendedores-grupoboticario',
  ERROR_PROCESS = 'process-error',
  ERROR_COMBO = 'combo-error',
  LOGIN = 'login',
  FAQ = 'perguntas-frequentes',
  LOGOUT = 'logout',
  PRODUCTS_BY_TAG = 'vitrines',
  EMPTY_RECOMMENDATION = 'recomendacao-indisponivel',
  TAPUME = 'indisponivel',
  CATEGORIES = 'categorias',
  COMBO = 'combo',
  GIFTS = 'checkout/brindes',
  CHECKOUT = 'checkout',
  CHECKOUT_CONFIRMATION = 'confirmation/:orderCode',
  DEPARTMENTS = ':department',
  DEPARTMENT = 'departamentos',
  SEARCH = 'pesquisa',
  PRODUCT_DETAIL = 'produto/:slugName',
  RECOVER_PASSWORD = 'recuperacao-de-senha',
  RECOVER_PASSWORD_EMAIL = 'email',
  RECOVER_PASSWORD_EMAIL_SUCCESS = 'sucesso',
  CART = 'carrinho',
  SPECIAL_PAYMENT_ERROR = 'pagamento-especial-erro',
}
